import React from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import socket from './Socket';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { cerrarSesionAccion } from '../../redux/UsuarioDucks';
const { useState, useEffect, useRef } = React;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const SesionExpirada = () => {
    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0].id
    const dispatch = useDispatch()

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            {bodyModal} <br /> <center><strong>¿Desea cerrar sesión?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-dark' onClick={() => {
                                switch (accion) {
                                    case 'cerrarSesion':
                                        cerrarSesion()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CERRAR SESIÓN</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const botonTokenExpirado = async () => {
        handleOpenModal({
            title: `¡ERROR. Su sesión ha expirado!`,
            body: `Cierre sesión e inicie sesión nuevamente para seguir realizando operaciones`,
            accion: 'cerrarSesion'
        })
    }
    const cerrarSesion = async () => {
        await dispatch(cerrarSesionAccion())
        window.location.reload(false);
      }
    useEffect(() => {
        socket.on('tokenExpiro', (token) => {
            if(token.data === localStorage.getItem('user')){
                botonTokenExpirado()
            }            
        })
    }, [socket])

    return (
        <div>
            {modalComponent()}
        </div>
    )
};

export default withRouter(SesionExpirada)
